import { Module } from '@nestjs/common';
import { PrismaModule } from 'src/prisma/prisma.module';
import { NotaCreditoPayloadService } from './nota-credito-payload.service';

@Module({
  imports: [PrismaModule],
  providers: [NotaCreditoPayloadService],
  exports: [NotaCreditoPayloadService],
})
export class NotaCreditoPayloadModule {}
